import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "../data/content";

const WhatsAppFloat = () => (
    <motion.a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-float-button"
        aria-label="Chat with the IHCC sales and marketing team on WhatsApp"
        initial={{ opacity: 0, scale: 0.5, y: 24 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ delay: 1.8, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.92 }}
        className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_14px_36px_-10px_rgba(37,211,102,0.6)] transition-shadow duration-300 hover:shadow-[0_18px_44px_-10px_rgba(37,211,102,0.75)]"
    >
        <span className="absolute inset-0 -z-10 animate-ping rounded-full bg-[#25D366]/40 [animation-duration:2.6s]" />
        <MessageCircle size={26} strokeWidth={1.8} />
    </motion.a>
);

export default WhatsAppFloat;
